import React from 'react';
import { Link } from 'react-router-dom';

const NewsPage = () => (
    <div>

        <p>News and Information</p>
        <p><Link to="/">Go home</Link></p>
    </div>
);

export default NewsPage;



// WEBPACK FOOTER //
// ./src/components/NewsPage.js